import React from 'react';
import SelectInput from './SelectInput';

const BooleanInput = ({ argument, onChange }) => {
  // Boolean is essentially a select with true/false options
  const booleanArgument = {
    ...argument,
    options: {
      ...argument.options,
      optionsList: [
        { value: 'true', label: 'Oui / Vrai' },
        { value: 'false', label: 'Non / Faux' },
      ],
      allowEmpty: !argument.obligatoire,
    },
  };

  return <SelectInput argument={booleanArgument} onChange={onChange} />;
};

export default BooleanInput;
